import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { toast } from 'react-toastify';
import { fetchFundingHistoryDataService, getManagementProfileUserData, getNetworkEntities, getLenderConnectionsData } from './service';

export async function fetchManagementProfileUserData(payload: FetchManagementProfileDataPayload) {
    try {
        const response = await getManagementProfileUserData(payload);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.responseBody;
            case JAVA_API_STATUS.ERROR:
                return toast.error(responseData?.responseMessage || 'Some error occurred');
        }
    } catch (err) {
        console.error('Error in fetching user data', err);
    }
}

export async function fetchFundingHistoryData(payload: { orgId: string; assesseeOrgId: string; taskStepsList: string[] }) {
    try {
        const response = await fetchFundingHistoryDataService(payload);
        const responseData = response?.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.responseBody || {};
            case JAVA_API_STATUS.ERROR:
                return toast.error(responseData?.responseMessage || 'Some error occurred');
        }
    } catch (err) {
        console.error('Error in fetching user data', err);
    }
}

export async function fetchCompaniesNetworkData(payload: { orgId: string }) {
    try {
        const response = await getNetworkEntities({ assesseeOrgId: payload.orgId });
        const responseData = response?.data?.responseData;

        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS: {
                const body = response?.data?.responseBody;
                return {
                    vendorFor: body?.vendorFor || [],
                    customerOf: body?.customerOf || [],
                    lastUpdatedAt: body?.lastUpdatedAt,
                    totalCompaniesInNetwork: body?.totalCompaniesInNetwork ?? 0,
                    networkRelatedPartyEntities: body?.networkRelatedPartyEntities || {},
                };
            }
            case JAVA_API_STATUS.ERROR:
            default:
                toast.error(responseData?.responseMessage || 'Some error occurred');
                return null;
        }
    } catch (err) {
        console.error('Error in fetching companies network data', err);
        return null;
    }
}

export async function fetchLenderConnectionsData(payload: { orgId: string }) {
    try {
        const response = await getLenderConnectionsData(payload);
        const responseData = response?.data?.responseData;

        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.data || [];
            case JAVA_API_STATUS.ERROR:
            default:
                return [];
        }
    } catch (err) {
        console.error('Error in fetching lender connections data', err);
        return [];
    }
}

type FetchManagementProfileDataPayload = {
    orgId: string;
    entityId: string;
    name: string;
    taskStepsList: string[];
};
